var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSinImagenNotificacionesZj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sin-imagen-notificaciones-zj_svg__clip0_1355_2639)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFEFE9",
    d: "M0 0h68v44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.727 10.395c0 3.696-3.113 6.687-7.14 6.687-4.03 0-6.96-2.99-6.96-6.86 0-3.699 3.11-6.687 6.96-6.687 4.027 0 7.14 2.993 7.14 6.86zm19.416 2.113s-8.791 8.797-26.19 8.27c-4.799-.152-8.046-1.764-11.535-3.499-4.634-2.303-9.703-4.82-19.418-4.42l2.565 5.104c14.1 2.11 24.174 12.317 24.174 23.049v22.525c0 5.628-.915 10.203-8.057 11.083l1.098 7.566c9.158-.352 17.215-2.993 17.215-18.123V30.101c8.243-3.871 17.583-8.62 22.345-14.25l-2.197-3.344z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sin-imagen-notificaciones-zj_svg__clip0_1355_2639"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h68v44H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/sin-imagen-notificaciones-zj.6fe5afc5.svg";
export { SvgSinImagenNotificacionesZj as ReactComponent };